import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const ChatSearchIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33398 7.49935C1.33398 6.98549 1.34296 6.48388 1.36004 5.99955C1.41586 4.41724 1.44378 3.62608 2.08736 2.97765C2.73095 2.32922 3.54445 2.29442 5.17145 2.22481C6.0641 2.18662 7.01458 2.16602 8.00065 2.16602C8.98672 2.16602 9.93718 2.18662 10.8298 2.22481C12.4568 2.29442 13.2704 2.32922 13.9139 2.97765C14.5575 3.62608 14.5854 4.41724 14.6412 5.99955C14.6583 6.48388 14.6673 6.98549 14.6673 7.49935C14.6673 8.01322 14.6583 8.51482 14.6412 8.99915C14.5854 10.5815 14.5575 11.3726 13.9139 12.0211C13.2704 12.6695 12.4569 12.7043 10.8298 12.7739C10.3405 12.7948 9.83385 12.8105 9.31352 12.8203C8.81945 12.8297 8.57238 12.8344 8.35532 12.9171C8.13825 12.9997 7.95565 13.1563 7.59032 13.4695L6.13734 14.7155C6.04914 14.7911 5.93678 14.8327 5.82059 14.8327C5.55184 14.8327 5.33398 14.6148 5.33398 14.3461V12.7806C5.2796 12.7784 5.22542 12.7762 5.17144 12.7739C3.54444 12.7043 2.73095 12.6695 2.08736 12.021C1.44378 11.3726 1.41586 10.5815 1.36004 8.99915C1.34296 8.51482 1.33398 8.01322 1.33398 7.49935Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6667 9.83271L9.58333 8.74938M10 7.16602C10 6.06144 9.1046 5.16602 8 5.16602C6.8954 5.16602 6 6.06144 6 7.16602C6 8.27058 6.8954 9.16604 8 9.16604C8.55227 9.16604 9.05227 8.94218 9.4142 8.58024C9.77613 8.21831 10 7.71831 10 7.16602Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
